import { CvaMarketingBodyProps } from '../../types';
import { CatHeading } from '@blocks-react/components/Heading';

export const CvaMarketingBody = ({
  className,
  children,
}: CvaMarketingBodyProps) => {
  return (
    <CatHeading variant="body" className={className}>
      {children}
    </CatHeading>
  );
};
